import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'white' | 'outline-white';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#C8102E] text-white hover:bg-[#A00D24] focus-visible:ring-[#C8102E]',
    secondary: 'bg-[#0A1F44] text-white hover:bg-[#163A70] focus-visible:ring-[#0A1F44]',
    outline: 'border-2 border-[#C8102E] text-[#C8102E] hover:bg-[#C8102E] hover:text-white',
    'outline-white': 'border-2 border-white text-white hover:bg-white hover:text-[#0A1F44]',
    ghost: 'hover:bg-[#F5F7FA] text-[#0A1F44]',
    white: 'bg-white text-[#0A1F44] hover:bg-[#F5F7FA] focus-visible:ring-[#0A1F44]'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: disabled || isLoading ? 1 : 1.02
  }} whileTap={{
    scale: disabled || isLoading ? 1 : 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-242">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-243" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-244">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-245">{rightIcon}</span>}
    </motion.button>;
}